function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Page-1",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "done_outline_28"
}, /*#__PURE__*/React.createElement("rect", {
  x: 0,
  y: 0,
  width: 28,
  height: 28
}), /*#__PURE__*/React.createElement("path", {
  d: "M11,18.5857864 L5.70710678,13.2928932 C5.31658249,12.9023689 4.68341751,12.9023689 4.29289322,13.2928932 C3.90236893,13.6834175 3.90236893,14.3165825 4.29289322,14.7071068 L10.2928932,20.7071068 C10.6834175,21.0976311 11.3165825,21.0976311 11.7071068,20.7071068 L23.7071068,8.70710678 C24.0976311,8.31658249 24.0976311,7.68341751 23.7071068,7.29289322 C23.3165825,6.90236893 22.6834175,6.90236893 22.2928932,7.29289322 L11,18.5857864 Z",
  id: "\\u21B3-Icon-Color",
  fill: "currentColor",
  fillRule: "nonzero"
})));

var SvgOk = function SvgOk(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "28px",
    height: "28px",
    viewBox: "0 0 28 28",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgOk, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/ok.d8974451.svg";
export { ForwardRef as ReactComponent };